import api from './client';

export const getWishlist = (userId) => api.get(`/wishlist/${userId}`).then((r) => r.data.data || []);

export const addToWishlist = (data) => api.post('/wishlist', data).then((r) => r.data);

export const removeFromWishlist = (data) => api.delete('/wishlist', { data }).then((r) => r.data);